import apiClient from "../helpers/apiClient";

export const employeePersonalInfoService = {
  getPersonalInfoOptions,
  getPersonalInfo,
  createPersonalInfo,
  updatePersonalInfo,
  deletePersonalInfo,
};

function displayValue(value) {
  return value === null || value === undefined || value === "" ? "-" : value;
}

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function mapPersonalInfo(raw = {}) {
  return {
    employeeId: displayValue(raw.employee_id),
    fathersName: displayValue(raw.fathers_name),
    mothersName: displayValue(raw.mothers_name),
    religionId: raw.religion_id ?? null,
    religionName: displayValue(raw.religion_name),
    bloodGroupId: raw.blood_group_id ?? null,
    bloodGroupName: displayValue(raw.blood_group_name),
    maritalStatusId: raw.marital_status_id ?? null,
    maritalStatusName: displayValue(raw.marital_status_name),
    personalEmail: displayValue(raw.personal_email),
    personalMobile: displayValue(raw.personal_mobile),
    emergencyContact: displayValue(raw.emergency_contact),
    relationshipId: raw.relationship_id ?? null,
    relationshipName: displayValue(raw.relationship_name),
  };
}

function getErrorMessage(error) {
  return error.response?.data?.msg || "Something went wrong";
}

function extractWriteResult(response) {
  const data = response?.data;
  const messageObject = Array.isArray(data?.result_status)
    ? data.result_status[0]
    : Array.isArray(data)
      ? data[0]
      : data;

  return {
    message:
      messageObject?.message_text ||
      messageObject?.Message_Text ||
      "Saved successfully.",
    refNo: messageObject?.message_ref_no ?? messageObject?.Message_Ref_No ?? null,
  };
}

async function handleRequest(request) {
  try {
    return await request();
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
}

async function handleWriteRequest(request) {
  try {
    const response = await request();
    return extractWriteResult(response);
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
}

function getPersonalInfoOptions() {
  return handleRequest(async () => {
    const response = await apiClient.get("/hr/employee-personal-info/options");
    const data = response?.data ?? {};
    return {
      religions: asArray(data.religion_info),
      bloodGroups: asArray(data.blood_group_info),
      maritalStatuses: asArray(data.marital_status_info),
      relationships: asArray(data.relationship_info),
    };
  });
}

// Resolves to null when the employee has no personal information yet.
function getPersonalInfo(employeeId) {
  return handleRequest(async () => {
    const response = await apiClient.get(`/hr/employees/${employeeId}/personal-info`);
    const [record] = asArray(response?.data?.personal_info);
    return record ? mapPersonalInfo(record) : null;
  });
}

function toBody(form) {
  return {
    fathers_name: form.fathersName,
    mothers_name: form.mothersName,
    religion_id: Number(form.religionId),
    blood_group_id: form.bloodGroupId ? Number(form.bloodGroupId) : null,
    marital_status_id: Number(form.maritalStatusId),
    personal_email: form.personalEmail,
    personal_mobile: form.personalMobile,
    emergency_contact: form.emergencyContact,
    relationship_id: form.relationshipId ? Number(form.relationshipId) : null,
  };
}

function createPersonalInfo(employeeId, form) {
  return handleWriteRequest(() =>
    apiClient.post(`/hr/employees/${employeeId}/personal-info`, toBody(form))
  );
}

function updatePersonalInfo(employeeId, form) {
  return handleWriteRequest(() =>
    apiClient.put(`/hr/employees/${employeeId}/personal-info`, toBody(form))
  );
}

function deletePersonalInfo(employeeId) {
  return handleWriteRequest(() =>
    apiClient.delete(`/hr/employees/${employeeId}/personal-info`)
  );
}
